import Vue from 'vue';
import Vuex from 'vuex';

import auth from './modules/auth';
import users from './modules/users';
import organizations from './modules/organizations';
import events from './modules/events';
import changeRequests from './modules/changeRequests';
import crisisManager from './modules/crisisManager';
import alerts from './modules/alerts';
import roadtrips from './modules/roadtrips';
import locations from './modules/locations';
import misc from './modules/misc';
import cities from './modules/cities';

Vue.use(Vuex);

const VuexPersistence = require('vuex-persist').default;

const vuexSession = new VuexPersistence({
  key: 'alabamapartners',
  localStorage,
  modules: ['auth'],
});

export default new Vuex.Store({
  plugins: [vuexSession.plugin],
  modules: {
    auth,
    users,
    organizations,
    events,
    changeRequests,
    crisisManager,
    alerts,
    roadtrips,
    locations,
    misc,
    cities,
  },
});
